import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Section from '../components/Section';
import * as Actions from '../actions';

function mapStateToProps(state) {
  return {
    data: state.luraschi.getIn(['data', 'data']),
    visible: !state.luraschi.getIn(['burger', 'opened'], false),
    lang: state.luraschi.get('lang', 'fr'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Section);



// WEBPACK FOOTER //
// ./common/containers/Section.js